import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Grid2, IconButton, Modal, Skeleton, TextField, Tooltip } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import uploadService from "../api/services/upload-service";
import { showErrorToastWithDelay, showSuccessToast } from "../helpers/utils";
import { ReactComponent as FileIconActive } from "../Icons/vuesax/document-text-active.svg";
import { ReactComponent as FileUploadIconDisabled } from "../Icons/vuesax/document-upload-disabled.svg";
import { ReactComponent as FileUploadIconActive } from "../Icons/vuesax/document-upload.svg";
import { ReactComponent as ImportIconActive } from "../Icons/vuesax/export-active.svg";
import { ReactComponent as ImportIconDisabled } from "../Icons/vuesax/export-disabled.svg";
import { PermissionsContext } from "../permission-context";
import SharedTable from "../components/shared-table";
const MrrDocumentsTable = ({ data, onRemovePatient }) => {
  const [open, setOpen] = useState(false);
  const [showTableSkeleton, setSkeleton] = useState(true);
  const [disableCloseButton, setDisableCloseButton] = useState(false);
  const [filePath, setFilePath] = useState("");
  const [fileSelected, setFileSelected] = useState(null);
  const [disableSave, setDisableSave] = useState(true);
  const [disableSelectFile, setDisableSelectFile] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const { loading, error, hasPermission } = useContext(PermissionsContext);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setDisableSave(true);
      setFilePath(file.name);
      setFileSelected(file);
      setDisableSave(false);
    }
  };

  const handleSubmit = async () => {
    setDisableSave(true);
    setDisableSelectFile(true);
    setDisableCloseButton(true);

    const formData = new FormData();
    formData.append("VfId", selectedPatient.vfId);
    formData.append("JobId", selectedPatient.jobId);
    formData.append("FolderName", selectedPatient.docFileLocation);
    formData.append("FileName", selectedPatient.docFileName.replace(/\.docx$/i, ".pdf"));
    formData.append("File", fileSelected);
    try {
      var result = await uploadService.uploadMrrFile(formData);
      if (result.status === 200 || result.status === 201) {
        if (onRemovePatient) onRemovePatient(selectedPatient.vfId, selectedPatient.jobId);
        showSuccessToast("Successfully Uploaded the File.");
      }
    } catch (error) {
      showErrorToastWithDelay("Upload Failed: " + error, 6000);
    } finally {
      setOpen(false);
      setSelectedPatient(null);
      setDisableSave(true);
      setFileSelected();
      setFilePath("");
      setDisableSelectFile(false);
      setDisableCloseButton(false);
    }
  };

  useEffect(() => {
    if (data != null) {
      setSkeleton(false);
    } else {
      setSkeleton(true);
    }
  }, [data]);

  const handleModal = (patient) => {
    setSelectedPatient(patient);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedPatient(null);
    setFileSelected();
    setFilePath("");
    setDisableSave(true);
  };

  const columns = [
    {
      title: "MRN",
      dataIndex: "mrn",
      width: "15%",
    },
    {
      title: "Patient Name",
      dataIndex: "patientName",
      width: "30%",
    },
    {
      title: "Date of Job",
      dataIndex: "visitDate",
      width: "22%",
      render: (text) =>
        text
          ? new Date(text).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })
          : "",
    },
    {
      title: "Date of Service",
      dataIndex: "estFileDatetime",
      width: "23%",
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a.estFileDatetime) - new Date(b.estFileDatetime),
      render: (text) =>
        text
          ? new Date(text).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })
          : "-",
    },
    {
      title: "Details",
      key: "details",
      width: "10%",
      render: (_, record) => (
        <Tooltip title='upload'>
          <span
            style={{ cursor: "pointer", display: "inline-flex" }}
            onClick={() => handleModal(record)}>
            <FileUploadIconActive width='1em' height='1em' style={{ fontSize: "22px" }} />
          </span>
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      {!loading && !error && hasPermission("MER") && (
        <div
          style={{
            margin: "12px 0",
            fontFamily: "DM Sans",
            minHeight: "60vh",
          }}>
          {showTableSkeleton ? (
            <Skeleton
              variant='rectangular'
              width='100%'
              height='60vh'
              sx={{ borderRadius: "15px" }}
              animation='wave'
            />
          ) : (
            <>
              <Grid2>
                <SharedTable
                  columns={columns}
                  dataSource={data}
                  rowKey={(record) => `${record.vfId}_${record.jobId}`}
                  tableName='mrr-documents-table'
                  scroll={{ x: "max-content" }}
                />
              </Grid2>
              <Grid2
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}>
                <Modal
                  open={open}
                  onClose={handleClose}
                  aria-labelledby='modal-modal-title'
                  aria-describedby='modal-modal-description'>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      width: "80%",
                      maxWidth: 600,
                      height: "auto",
                      borderRadius: "12px",
                      bgcolor: "white",
                      boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
                      padding: 2,
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      "@media (max-width:600px)": {
                        width: "90%",
                        padding: 1,
                      },
                      "& .MuiPaper-root": {
                        outline: "none",
                        boxShadow: "none",
                      },
                    }}>
                    <Tooltip title='Close'>
                      <IconButton
                        aria-label='close'
                        disabled={disableCloseButton}
                        onClick={handleClose}
                        sx={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          zIndex: 10,
                        }}>
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>

                    <Grid2 container sx={{ height: "100%" }}>
                      <Grid2 container size={12} spacing={4} sx={{ padding: "31px" }}>
                        <Grid2 xs={6}>
                          <Tooltip
                            title={
                              selectedPatient?.patientName &&
                              selectedPatient.patientName.trim() !== ""
                                ? selectedPatient.patientName
                                : "Not available"
                            }
                            arrow>
                            <TextField
                              label='Patient Name'
                              value={
                                selectedPatient?.patientName &&
                                selectedPatient.patientName.trim() !== ""
                                  ? selectedPatient.patientName
                                  : "Not available"
                              }
                              fullWidth
                              InputProps={{
                                readOnly: true,
                                style: {
                                  color: "#6c757d",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  borderRadius: "12px",
                                },
                              }}
                            />
                          </Tooltip>
                        </Grid2>

                        <Grid2 xs={6}>
                          <Tooltip
                            title={
                              selectedPatient?.mrn && selectedPatient.mrn.trim() !== ""
                                ? selectedPatient.mrn
                                : "Not available"
                            }
                            arrow>
                            <TextField
                              label='MRN'
                              value={
                                selectedPatient?.mrn && selectedPatient.mrn.trim() !== ""
                                  ? selectedPatient.mrn
                                  : "Not available"
                              }
                              fullWidth
                              InputProps={{
                                readOnly: true,
                                style: {
                                  color: "#6c757d",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  borderRadius: "12px",
                                },
                              }}
                            />
                          </Tooltip>
                        </Grid2>
                      </Grid2>
                      <Grid2
                        container
                        size={12}
                        justifyContent='space-evenly'
                        alignItems='center'
                        spacing={4}>
                        <Grid2 xs={12} sm={6}>
                          <TextField
                            id='outlined-multiline-flexible'
                            placeholder='File'
                            maxRows={4}
                            value={
                              filePath.length > 30 ? `${filePath.substring(0, 30)}...` : filePath
                            }
                            InputProps={{
                              readOnly: true,
                            }}
                            title={filePath}
                            sx={{
                              width: "100%",
                              maxWidth: 400,
                              minWidth: 300,
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "12px",
                              },
                              "& .MuiOutlinedInput-input": {
                                padding: "10px 14px",
                                marginBottom: "1px",
                                color: "#6c757d",
                              },
                              "@media (max-width:600px)": {
                                minWidth: 200,
                              },
                            }}
                          />
                        </Grid2>

                        <Grid2 xs={12} sm={6}>
                          <input
                            accept='.pdf'
                            id='file-upload'
                            type='file'
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                            disabled={disableSelectFile}
                          />
                          <label htmlFor='file-upload'>
                            <Button
                              variant='contained'
                              color='primary'
                              component='span'
                              type='submit'
                              startIcon={
                                disableSelectFile ? (
                                  <FileUploadIconDisabled width='1em' height='1em' />
                                ) : (
                                  <FileIconActive width='1em' height='1em' />
                                )
                              }
                              disabled={disableSelectFile}
                              fullWidth>
                              Select File
                            </Button>
                          </label>
                        </Grid2>
                      </Grid2>

                      <Grid2
                        container
                        size={12}
                        p={4}
                        justifyContent='space-evenly'
                        alignItems='center'>
                        <Button
                          variant='contained'
                          color='primary'
                          component='span'
                          startIcon={
                            disableSelectFile || disableSave ? (
                              <ImportIconDisabled width='1em' height='1em' />
                            ) : (
                              <ImportIconActive width='1em' height='1em' />
                            )
                          }
                          onClick={handleSubmit}
                          disabled={disableSelectFile || disableSave}
                          fullWidth>
                          Upload
                        </Button>
                      </Grid2>
                    </Grid2>
                  </Box>
                </Modal>
              </Grid2>
            </>
          )}
        </div>
      )}
    </>
  );
};
export default MrrDocumentsTable;
